import * as React from "react"
import type { SVGProps } from "react"
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m9.55 15.15 8.48-8.47q.3-.3.7-.3t.7.3.3.7-.3.72l-9.18 9.2q-.3.3-.7.3a1 1 0 0 1-.7-.3L4.55 13a1 1 0 0 1-.29-.71 1 1 0 0 1 .31-.71q.3-.3.72-.3.4 0 .71.3z" />
  </svg>
)
export default SvgCheck
